var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{attrs:{"variant":"link"},on:{"click":function($event){$event.preventDefault();return _vm.abrirChat()}}},[_c('small',[_vm._v("Ver mensagem")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }